exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step__item[data-v-939bd980] {\n  background-color: #f1f1f1;\n}\n.review-wrapper[data-v-939bd980] {\n  max-width: 100%;\n}\n.img-fluid[data-v-939bd980] {\n  max-height: 200px;\n  text-align: center;\n  display: block;\n  margin: 0 auto;\n}\n.button__steps[data-v-939bd980] {\n  min-width: 120px;\n}\n", ""]);

// exports
